import footerLogo from "./assets/robogebra-footer-logo.svg"
import playStoreBadge from "./assets/play-store.png"
import appStoreBadge from "./assets/app-store.png"
import scrollIcon from "./assets/scroll-to-top.svg"
import sampleSolution1 from "./assets/sample-solutions/box-sum.png"
import sampleSolution2 from "./assets/sample-solutions/solutionimage11.png"
import sampleSolution3 from "./assets/sample-solutions/solutionimage12.png"
import sampleSolution4 from "./assets/sample-solutions/solutionimage5.png"
import robogebraOGBanner from "./assets/sample-solutions/robogebra-og.jpg"



//navbar-overlay-menu
document.addEventListener("DOMContentLoaded", function () {
    const robogebraOGBanner1 = robogebraOGBanner; // TODO... Don't Remove
    const menuIcon = document.getElementById('menuIcon');
    if (menuIcon) {
        menuIcon.addEventListener('click', toggleMenu);
    }

    const overlayMenuIcon = document.getElementById('overlayMenu');
    if (overlayMenuIcon) {
        overlayMenuIcon.addEventListener('click', onOverlayMenuClick);
    }

    function toggleMenu() {
        overlayMenuIcon.classList.toggle('open');
        if (overlayMenuIcon.classList.contains('open')) {
            menuIcon.classList.remove('fa-bars');
            menuIcon.classList.add('fa-times');
        } else {
            menuIcon.classList.remove('fa-times');
            menuIcon.classList.add('fa-bars');
        }
    }

    function onOverlayMenuClick() {
        overlayMenuIcon.classList.toggle('open');
        menuIcon.classList.remove('fa-times');
        menuIcon.classList.add('fa-bars');
    }
});

// "Book a Demo" → centre the whole section in the viewport.
// A plain #book-a-demo jump puts the section's top edge at the top of the
// screen, so only the heading is visible and the points and contact boxes sit
// below the fold. This centres it when it fits, and falls back to a top-aligned
// jump when the section is taller than the viewport.
document.addEventListener("DOMContentLoaded", function () {
    const DEMO_ID = 'book-a-demo';

    function desiredScrollTop() {
        const target = document.getElementById(DEMO_ID);
        if (!target) return null;

        const rect = target.getBoundingClientRect();
        const top = rect.top + window.scrollY;
        const viewport = window.innerHeight;
        const offset = rect.height <= viewport
            ? top - (viewport - rect.height) / 2   // fits: centre it
            : top - 24;                            // taller: align near the top

        return Math.max(0, offset);
    }

    // The section's position moves while the scroll is running: images and
    // iframes between here and there load on approach and push it down. A
    // fire-and-forget scroll therefore aims at a stale target and lands short
    // — on the previous section — and any after-the-fact correction shows up
    // as a second, separate jump.
    //
    // So drive the animation frame by frame and re-read the target on every
    // frame. Layout shifts are absorbed continuously and the motion stays one
    // smooth glide.
    //
    // Every step must use behavior:'instant', NOT 'auto'. Per CSSOM-View,
    // 'auto' means "use the element's CSS scroll-behavior" — and Bootstrap
    // sets scroll-behavior:smooth on :root. With 'auto' each frame kicks off
    // a fresh smooth animation that cancels the previous one, so the page
    // crawls a little way and stalls instead of reaching the section.
    function animateToDemo() {
        let cancelled = false;

        function onUserInput() { cancelled = true; }
        ['wheel', 'touchstart', 'keydown'].forEach(function (evt) {
            window.addEventListener(evt, onUserInput, {passive: true});
        });

        function done() {
            ['wheel', 'touchstart', 'keydown'].forEach(function (evt) {
                window.removeEventListener(evt, onUserInput);
            });
        }

        const start = window.scrollY;
        const startedAt = performance.now();

        // Scale the duration to the distance. This section sits ~4500px down,
        // and covering that in a flat 700ms reads as a jump rather than a
        // scroll. Roughly 0.35ms per pixel, clamped so short hops stay snappy
        // and long ones stay watchable.
        const distance = Math.abs((desiredScrollTop() || 0) - start);
        const duration = Math.min(1600, Math.max(450, distance * 0.35));

        // Tracks the target for a moment after the glide ends, in case
        // something below is still resolving. Eased, so it never snaps.
        function track(settleUntil) {
            if (cancelled || performance.now() > settleUntil) return done();

            const want = desiredScrollTop();
            if (want === null) return done();

            const gap = want - window.scrollY;
            if (Math.abs(gap) > 1) {
                window.scrollTo({top: window.scrollY + gap * 0.25, behavior: 'instant'});
            }
            requestAnimationFrame(function () { track(settleUntil); });
        }

        function frame(now) {
            if (cancelled) return done();

            const want = desiredScrollTop();
            if (want === null) return done();

            const p = Math.min(1, (now - startedAt) / duration);
            // easeInOutCubic — softer start and finish than quad over a long
            // distance, so it doesn't feel like it launches.
            const eased = p < 0.5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2;

            window.scrollTo({top: start + (want - start) * eased, behavior: 'instant'});

            if (p < 1) {
                requestAnimationFrame(frame);
            } else {
                track(performance.now() + 600);
            }
        }

        requestAnimationFrame(frame);
    }

    function scrollToDemo(smooth) {
        if (desiredScrollTop() === null) return;

        if (!smooth) {
            window.scrollTo({top: desiredScrollTop(), behavior: 'instant'});
            return;
        }

        animateToDemo();
    }

    document.querySelectorAll('a[href$="#' + DEMO_ID + '"]').forEach(function (link) {
        // Same-page links only; ./index.html#book-a-demo must still navigate.
        if (!link.getAttribute('href').startsWith('#')) return;

        link.addEventListener('click', function (event) {
            event.preventDefault();
            scrollToDemo(true);
            history.replaceState(null, '', '#' + DEMO_ID);
        });
    });

    // Arriving from another page, once images have settled and stopped shifting
    // the layout underneath us.
    if (window.location.hash === '#' + DEMO_ID) {
        window.addEventListener('load', function () {
            setTimeout(function () { scrollToDemo(false); }, 100);
        });
    }
});

//scroll-top-fuctionality
document.addEventListener("DOMContentLoaded", function () {
    const backToTopButton = document.getElementById("scrollTopBtn");

    if (backToTopButton) {
        window.addEventListener("scroll", () => {
            if (window.scrollY > window.innerHeight) {
                backToTopButton.style.display = "block";
            } else {
                backToTopButton.style.display = "none";
            }
        });

        backToTopButton.addEventListener("click", () => {
            window.scrollTo({top: 0, behavior: "smooth"});
        });
    }
});

document.addEventListener("DOMContentLoaded", function () {
    const buttons = document.querySelectorAll('.abt-see-more-btn');

    buttons.forEach(button => {
        button.addEventListener('click', function () {
            const container = this.closest('.team-container');

            // Toggle expansion
            container.classList.toggle('expanded');

            // Optional: Toggle button text
            if (container.classList.contains('expanded')) {
                this.textContent = 'See less...';
            } else {
                this.textContent = 'See more...';
            }
        });
    });

    // Collapse when clicking outside
    document.addEventListener('click', function (event) {
        const expandedContainers = document.querySelectorAll('.team-container.expanded');

        expandedContainers.forEach(container => {
            if (!container.contains(event.target)) {
                container.classList.remove('expanded');

                // Reset the button text to "See more"
                const btn = container.querySelector('.abt-see-more-btn');
                if (btn) btn.textContent = 'See more...';
            }
        });
    });
});

// About-us section logic
document.addEventListener("DOMContentLoaded", () => {
    const topBio = document.getElementById("top-bio");
    const cards = document.querySelectorAll(".team-card");

    if (!topBio || cards.length === 0) return;

    // Attach click listeners to all cards
    cards.forEach(card => {
        card.addEventListener("click", () => {
            // Remove 'active' class from all cards
            cards.forEach(c => c.classList.remove("active"));
            // Add 'active' class to clicked card
            card.classList.add("active");

            // Show the bio
            const bio = card.getAttribute("data-bio");
            topBio.innerText = bio;
            topBio.classList.add("visible");
        });
    });
    // Select the first card by default
    cards[0].click();
});

// Audio Player Functionality
document.addEventListener('DOMContentLoaded', function() {
    const audioPlayer = document.getElementById('audioPlayer');
    const playPauseBtn = document.getElementById('playPauseBtn');

    if (!audioPlayer || !playPauseBtn) return;

    const playIcon = playPauseBtn.querySelector('.play-icon');
    const pauseIcon = playPauseBtn.querySelector('.pause-icon');
    const progressFill = document.getElementById('progressFill');
    const progressThumb = document.getElementById('progressThumb');
    const progressBar = document.querySelector('.progress-bar');
    const currentTimeDisplay = document.getElementById('currentTime');

    let isDragging = false;

    // Format time helper function
    function formatTime(seconds) {
        const mins = Math.floor(seconds / 60);
        const secs = Math.floor(seconds % 60);
        return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    }

    // Update progress bar
    function updateProgress() {
        if (isDragging) return;

        const duration = audioPlayer.duration || 0;
        const currentTime = audioPlayer.currentTime || 0;
        const progressPercent = duration ? (currentTime / duration) * 100 : 0;

        progressFill.style.width = progressPercent + '%';
        progressThumb.style.left = progressPercent + '%';
        currentTimeDisplay.textContent = formatTime(currentTime);
    }

    // Play/Pause functionality
    playPauseBtn.addEventListener('click', function() {
        if (audioPlayer.paused) {
            audioPlayer.play().then(() => {
                playIcon.style.display = 'none';
                pauseIcon.style.display = 'block';
            }).catch(error => {
                console.error('Error playing audio:', error);
            });
        } else {
            audioPlayer.pause();
            playIcon.style.display = 'block';
            pauseIcon.style.display = 'none';
        }
    });

    // Progress bar click/drag functionality
    function updateAudioTime(event) {
        const progressBarRect = progressBar.getBoundingClientRect();
        const clickX = event.clientX - progressBarRect.left;
        const progressBarWidth = progressBarRect.width;
        const clickPercent = (clickX / progressBarWidth) * 100;
        const newTime = (clickPercent / 100) * audioPlayer.duration;

        if (isFinite(newTime)) {
            audioPlayer.currentTime = newTime;
            updateProgress();
        }
    }

    progressBar.addEventListener('click', updateAudioTime);

    // Drag functionality for progress thumb
    progressThumb.addEventListener('mousedown', function(e) {
        isDragging = true;
        e.preventDefault();
    });

    document.addEventListener('mousemove', function(e) {
        if (isDragging) {
            updateAudioTime(e);
        }
    });

    document.addEventListener('mouseup', function() {
        isDragging = false;
    });

    // Audio event listeners
    audioPlayer.addEventListener('timeupdate', updateProgress);

    audioPlayer.addEventListener('loadedmetadata', function() {
        currentTimeDisplay.textContent = formatTime(0);
        updateProgress();
    });

    audioPlayer.addEventListener('ended', function() {
        playIcon.style.display = 'block';
        pauseIcon.style.display = 'none';
        progressFill.style.width = '0%';
        progressThumb.style.left = '0%';
        currentTimeDisplay.textContent = formatTime(0);
    });

    // Initialize display
    currentTimeDisplay.textContent = '03:00'; // Default duration as shown in image
});

// Coming Soon Modal Functions - Global scope
window.showComingSoonModal = function() {
    const modal = document.getElementById('comingSoonModal');
    if (modal) {
        modal.style.display = 'block';
        document.body.style.overflow = 'hidden';
    }
}

window.hideComingSoonModal = function() {
    const modal = document.getElementById('comingSoonModal');
    if (modal) {
        modal.style.display = 'none';
        document.body.style.overflow = 'auto';
    }
}

// Close modal when clicking outside of it
document.addEventListener('DOMContentLoaded', function() {
    const modal = document.getElementById('comingSoonModal');
    if (modal) {
        modal.addEventListener('click', function(event) {
            if (event.target === modal) {
                hideComingSoonModal();
            }
        });
    }

    // Load shared footer
    loadSharedFooter();
});

// Shared Footer Component
function loadSharedFooter() {
    const footerHTML = `
        <footer class="footer-container">
            <div class="container-xl">
                <div class="row py-md-5 justify-content-center">
                    <!-- Logo Section -->
                    <div class="col-md-3 col-sm-12 d-flex flex-column align-items-center justify-content-center footer-logo-section">
                        <img src="${footerLogo}" alt="Robogebra Logo" class="footer-logo-img">
                    </div>

                    <!-- Company Section -->
                    <div class="col-md-3 col-6 d-flex flex-column align-items-center">
                        <h5 style="color: #000000; font-weight: 400; text-transform: uppercase; font-size: 14px;" class="mb-0">Company</h5>
                        <ul class="list-unstyled mt-3 mb-0 ms-3">
                            <li class="mb-2"><a href="./index.html#book-a-demo" style="color: #8B4B99; text-decoration: none;">Book a Demo</a></li>
                            <li class="mb-2"><a href="./about-us.html" style="color: #8B4B99; text-decoration: none;">About Us</a></li>
                            <li class="mb-2"><a href="./team.html" style="color: #8B4B99; text-decoration: none;">Team</a></li>
                            <li class="mb-2"><a href="./contact-us.html" style="color: #8B4B99; text-decoration: none;">Contact Us</a></li>
                            <li class="mb-2"><a href="https://app.robogebra.ai/login" target="_blank" style="color: #8B4B99; text-decoration: none;">Sign in</a></li>
                        </ul>
                    </div>

                    <!-- Connect with Us Section -->
                    <div class="col-md-3 col-6 d-flex flex-column align-items-center">
                        <h5 style="color: #000000; font-weight: 400; text-transform: uppercase; font-size: 14px; margin-left: 24px;" class="mb-0">Connect with Us</h5>
                        <ul class="list-unstyled mt-3  mb-0">
                            <li class="mb-2">
                                <a href="https://www.linkedin.com/company/robogebra-ai" target="_blank" style="color: #8B4B99; text-decoration: none;">
                                    <i class="fab fa-linkedin" style="color: #8B4B99; margin-right: 8px;"></i>LinkedIn
                                </a>
                            </li>
                            <li class="mb-2">
                                <a href="https://www.youtube.com/@robogebra" target="_blank" style="color: #8B4B99; text-decoration: none;">
                                    <i class="fab fa-youtube" style="color: #8B4B99; margin-right: 8px;"></i>YouTube
                                </a>
                            </li>
                            <li class="mb-2">
                                <a href="https://www.instagram.com/robogebra" target="_blank" style="color: #8B4B99; text-decoration: none;">
                                    <i class="fab fa-instagram" style="color: #8B4B99; margin-right: 8px;"></i>Instagram
                                </a>
                            </li>
                            <li class="mb-2">
                                <a href="https://x.com/robogebra_ai" target="_blank" style="color: #8B4B99; text-decoration: none;">
                                    <i class="fab fa-x-twitter" style="color: #8B4B99; margin-right: 8px;"></i>X
                                </a>
                            </li>
                            <li class="mb-2">
                                <a href="https://robogebra.discourse.group/" target="_blank" style="color: #8B4B99; text-decoration: none;">
                                    <i class="fab fa-discourse" style="color: #8B4B99; margin-right: 8px;"></i>Community
                                </a>
                            </li>
                        </ul>
                    </div>

                    <!-- "Ready to Try It?" app badges -->
                    <div class="col-md-3 col-12 d-flex flex-column align-items-center footer-apps-section">
                        <h5 style="color: #000000; font-weight: 400; text-transform: uppercase; font-size: 14px;" class="mb-0">Ready to Try It?</h5>
                        <div class="footer-app-badges mt-3">
                            <a class="webapp-badge" href="https://app.robogebra.ai/login" target="_blank" rel="noopener">
                                <i class="fa-solid fa-globe webapp-badge-icon" aria-hidden="true"></i>
                                <span class="webapp-badge-text">
                                    <span class="webapp-badge-small">Open the</span>
                                    <span class="webapp-badge-large">Web App</span>
                                </span>
                            </a>
                            <a href="https://play.google.com/store/apps/details?id=io.robogebra.one" target="_blank" rel="noopener">
                                <img src="${playStoreBadge}" class="footer-app-badge-img" alt="Get it on Google Play">
                            </a>
                            <a href="https://apps.apple.com/in/app/robogebra-ai/id6755290170" target="_blank" rel="noopener">
                                <img src="${appStoreBadge}" class="footer-app-badge-img" alt="Download on the App Store">
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </footer>

        <!-- Bottom Footer Bar -->
        <div class="bottom-footer-bar">
            <div class="container-xl">
                <div class="row py-3 align-items-center justify-content-center">
                    <div class="col-md-4 col-sm-12 text-center">
                        <p class="mb-0" style="color: #9ca3af;">
                            <strong style="color: #fff;">Contact Us</strong>
                            <a href="mailto:support@robogebra.ai" style="color: #9ca3af; text-decoration: none;">support@robogebra.ai</a>
                        </p>
                    </div>
                    <div class="col-md-4 col-sm-12 text-center">
                        <p class="mb-0" style="color: #9ca3af;">
                            <strong style="color: #fff;">Legal</strong>
                            <a href="./terms.html" style="color: #9ca3af; text-decoration: none;">Terms of Service</a>
                            <span class="mx-2" style="color: #9ca3af;">|</span>
                            <a href="./policy.html" style="color: #9ca3af; text-decoration: none;">Privacy Policy</a>
                        </p>
                    </div>
                    <div class="col-md-4 col-sm-12 text-center">
                        <p class="mb-0" style="color: #9ca3af;"><strong style="color: #fff;">Copyright</strong> © 2025 Robogebra LLP</p>
                    </div>
                </div>
            </div>
        </div>
        
        
        <button id="scrollTopBtn" class="scroll-top-btn" style="cursor: pointer!important;">
            <img src="${scrollIcon}" alt="scroll-icon" class="scroll-icon me-1">
            Go to Top
        </button>
    `;

    // Find existing footer and replace it, or add to end of body if no footer exists
    const existingFooter = document.querySelector('footer.footer-container');
    const existingScrollBtn = document.querySelector('#scrollTopBtn');
    const existingBottomFooter = document.querySelector('.bottom-footer-bar');

    if (existingFooter) {
        // Remove existing components
        existingFooter.remove();
        if (existingScrollBtn) existingScrollBtn.remove();
        if (existingBottomFooter) existingBottomFooter.remove();
    }

    // Add the new footer before the last script tag
    const scripts = document.querySelectorAll('script');
    const lastScript = scripts[scripts.length - 1];
    lastScript.insertAdjacentHTML('beforebegin', footerHTML);

    // Initialize scroll to top functionality
    initializeScrollToTop();
}

// Initialize scroll to top functionality
function initializeScrollToTop() {
    const scrollTopBtn = document.getElementById('scrollTopBtn');
    if (scrollTopBtn) {
        // Show/hide scroll button based on scroll position
        window.addEventListener('scroll', function() {
            if (window.pageYOffset > 300) {
                scrollTopBtn.style.display = 'flex';
            } else {
                scrollTopBtn.style.display = 'none';
            }
        });

        // Scroll to top when button is clicked
        scrollTopBtn.addEventListener('click', function() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });
    }
}
const solutionData = [
    {
        id: 1,
        image: sampleSolution1,
        url:"https://app.robogebra.ai/exercise/6745963c7ce9d810b13f1828/exercise-item/17/solution"
    },
    {
        id: 2,
        image: sampleSolution3,
        url:"https://app.robogebra.ai/exercise/687b3c32cca0583e95ec69ca/exercise-item/1/solution"
    },
    {
        id: 3,
        image: sampleSolution2,
        url:"https://app.robogebra.ai/exercise/673601373f90cacab21ea985/exercise-item/6/solution"
    },
    {
        id: 4,
        image: sampleSolution4,
        url:"https://app.robogebra.ai/exercise/673601393f90cacab21ea9c1/exercise-item/4/solution"
    }
];
const solutionsGrid = document.getElementById('solutionsGrid');
const modalOverlay = document.getElementById('modalOverlay');
const modalImage = document.getElementById('modalImage');
const modalClose = document.getElementById('modalClose');
function createGridItems() {
    solutionsGrid.innerHTML = '';

    solutionData.forEach(solution => {
        const gridItem = document.createElement('div');
        gridItem.className = 'solution-item';
        gridItem.innerHTML = `
            <img class="solution-image" src="${solution.image}" loading="lazy">
            <div class="solution-overlay">
                <div class="zoom-icon">🔍</div>
            </div>`;

        gridItem.addEventListener('click', () => {
            if (solution.url) {
                window.open(solution.url, '_blank', 'noopener,noreferrer');
            }
        });

        const img = gridItem.querySelector('.solution-image');
        img.addEventListener('error', () => {
            img.style.color = 'white';
            img.style.display = 'flex';
            img.style.alignItems = 'center';
            img.style.justifyContent = 'center';
            img.style.fontSize = '1.2rem';
            img.style.fontWeight = '600';
            img.alt = 'Sample Solution';
        });

        solutionsGrid.appendChild(gridItem);
    });
}

function openModal(solution) {
    modalImage.src = solution.image;
    modalOverlay.classList.add('active');
    document.body.style.overflow = 'hidden';
}


function closeModal() {
    modalOverlay.classList.remove('active');
    document.body.style.overflow = '';
}


/* The sample-solutions grid and its modal are not on every page. Without this
   guard the module threw here and every listener registered further down —
   the download player and both carousels — was never wired up. */
if (solutionsGrid && modalOverlay && modalClose) {
    modalClose.addEventListener('click', closeModal);

    modalOverlay.addEventListener('click', (e) => {
        if (e.target === modalOverlay) {
            closeModal();
        }
    });

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && modalOverlay.classList.contains('active')) {
            closeModal();
        }
    });

    document.addEventListener('DOMContentLoaded', () => {
        createGridItems();
    });
}

document.addEventListener('DOMContentLoaded', function() {
    // Testimonials Carousel
    initCardCarousel({
        track: document.querySelector('.testimonials-track'),
        prevBtn: document.querySelector('.testimonial-prev'),
        nextBtn: document.querySelector('.testimonial-next'),
        cardSelector: '.testimonial-card'
    });

    // School Workshops Carousel — same mechanics, driven only by the arrows,
    // swipe or keyboard (no auto-advance).
    initCardCarousel({
        track: document.querySelector('.workshops-track'),
        prevBtn: document.querySelector('.workshop-prev'),
        nextBtn: document.querySelector('.workshop-next'),
        cardSelector: '.workshop-card'
    });

    // Sample Worksheets Carousel — one card per view, so it also gets dots:
    // with no neighbouring card peeking in, they're the only cue that there
    // are more worksheets to see.
    initCardCarousel({
        track: document.querySelector('.worksheets-track'),
        prevBtn: document.querySelector('.worksheet-prev'),
        nextBtn: document.querySelector('.worksheet-next'),
        cardSelector: '.worksheet-card',
        dots: document.getElementById('worksheetDots'),
        dotClass: 'worksheet-dot',
        dotLabel: (i, total) => `Show worksheet ${i + 1} of ${total}`
    });
});

/* Shared horizontal card carousel used by the testimonials, school workshops
   and sample worksheets sections. Each is a scrollable flex track plus two
   arrows that loop — next from the last card goes to the first, prev from the
   first goes to the last — so the mechanics live here once and each section
   only supplies its own selectors.

   Alignment is done against the real card positions instead of a fixed step,
   so the gap difference across breakpoints can never make cards drift
   off-edge. */
function initCardCarousel({ track, prevBtn, nextBtn, cardSelector,
                            dots = null, dotClass = '', dotLabel = null }) {
    if (!track || !prevBtn || !nextBtn) return;

    const getCards = () => Array.from(track.querySelectorAll(cardSelector));

    const getCurrentIndex = () => {
        const cards = getCards();
        const trackLeft = track.getBoundingClientRect().left;
        let index = 0;
        let closest = Infinity;
        cards.forEach((card, i) => {
            const distance = Math.abs(card.getBoundingClientRect().left - trackLeft);
            if (distance < closest - 1) {
                closest = distance;
                index = i;
            }
        });
        return index;
    };

    const scrollToIndex = (index) => {
        const cards = getCards();
        if (!cards.length) return;
        const target = cards[Math.max(0, Math.min(index, cards.length - 1))];
        const delta = target.getBoundingClientRect().left - track.getBoundingClientRect().left;
        track.scrollTo({ left: track.scrollLeft + delta, behavior: 'smooth' });
    };

    const isAtStart = () => track.scrollLeft <= 5;
    const isAtEnd = () => track.scrollLeft >= track.scrollWidth - track.clientWidth - 5;

    // Direct jump to an index (used by the dots — no wrapping needed there).
    const goToIndex = (index) => {
        const count = getCards().length;
        if (!count) return;
        scrollToIndex(((index % count) + count) % count);
    };

    // Step one card in a direction, wrapping at the ends. With several cards
    // visible per view, the scroll position can already be maxed out before
    // getCurrentIndex() ever reports the last index (the last card doesn't
    // land on the track's left edge), so the wrap has to be driven off the
    // actual scroll position rather than off index + 1 reaching the count.
    const step = (direction) => {
        const cards = getCards();
        if (!cards.length) return;
        if (direction > 0 && isAtEnd()) {
            scrollToIndex(0);
        } else if (direction < 0 && isAtStart()) {
            scrollToIndex(cards.length - 1);
        } else {
            scrollToIndex(getCurrentIndex() + direction);
        }
    };

    // Dots are opt-in — only the one-card-per-view carousels need them.
    // They're built from the cards in the markup, so adding a card is enough.
    const dotButtons = [];
    if (dots) {
        const cards = getCards();
        cards.forEach((card, i) => {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = dotClass;
            dot.setAttribute('aria-label', dotLabel ? dotLabel(i, cards.length) : `Go to item ${i + 1}`);
            dot.addEventListener('click', () => goToIndex(i));
            dots.appendChild(dot);
            dotButtons.push(dot);
        });
    }

    const syncDots = () => {
        if (!dotButtons.length) return;
        // At the far end the last card can sit short of the track's left edge,
        // so trust the scroll position rather than the nearest-card guess.
        const index = isAtEnd() ? dotButtons.length - 1 : getCurrentIndex();
        dotButtons.forEach((dot, i) => {
            const active = i === index;
            dot.classList.toggle('is-active', active);
            dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
    };

    prevBtn.addEventListener('click', () => step(-1));
    nextBtn.addEventListener('click', () => step(1));

    // Keyboard: the track is focusable in markup that opts in with tabindex.
    track.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight') {
            event.preventDefault();
            step(1);
        } else if (event.key === 'ArrowLeft') {
            event.preventDefault();
            step(-1);
        }
    });

    track.addEventListener('scroll', syncDots, { passive: true });
    syncDots();

    // Re-align after a resize / orientation change
    let resizeTimer;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        const index = getCurrentIndex();
        resizeTimer = setTimeout(() => {
            scrollToIndex(index);
            syncDots();
        }, 150);
    });
}

/* Enlarged view for the inline clips — the "With Robogebra" comparison tile and
   the three feature clips. Any element with .video-zoom opens the shared
   lightbox, so adding another clip needs no JS change.

   The clip's URL and poster are read off its own inline <video> rather than
   from data attributes: Parcel rewrites src/poster to content-hashed paths at
   build time but leaves data-* alone, so a URL parked in a data attribute
   would 404 in the built site.

   The lightbox keeps its own <video> so the inline loops are left running, but
   it picks up the clicked clip's playback position, which makes the jump to the
   enlarged view seamless. */
document.addEventListener('DOMContentLoaded', function () {
    const triggers = document.querySelectorAll('.video-zoom');
    const lightbox = document.getElementById('videoLightbox');
    const closeBtn = document.getElementById('videoLightboxClose');
    const bigVideo = document.getElementById('videoLightboxVideo');
    const titleEl = document.getElementById('videoLightboxTitle');

    if (!triggers.length || !lightbox || !closeBtn || !bigVideo || !titleEl) return;

    let lastTrigger = null;

    function openLightbox(trigger) {
        const inlineVideo = trigger.querySelector('video');
        const sourceEl = inlineVideo && inlineVideo.querySelector('source');
        const src = sourceEl ? sourceEl.src : (inlineVideo && inlineVideo.currentSrc);
        if (!src) return;

        lastTrigger = trigger;
        titleEl.textContent = trigger.getAttribute('data-video-title') || '';

        // Only reload when the clip actually changes — otherwise reopening the
        // same one would throw away what the browser already buffered.
        if (bigVideo.src !== src) {
            // Carry over the clip's dimensions so the element knows its aspect
            // ratio straight away. Without them a <video> reports the default
            // 300x150 until metadata arrives, and the card opens at that size
            // instead of filling the space the CSS allows.
            const width = inlineVideo.getAttribute('width');
            const height = inlineVideo.getAttribute('height');
            if (width && height) {
                bigVideo.setAttribute('width', width);
                bigVideo.setAttribute('height', height);
            }

            bigVideo.src = src;
            if (inlineVideo.poster) bigVideo.poster = inlineVideo.poster;
            bigVideo.load();
        }

        lightbox.classList.add('active');
        // Next frame, so the display change lands before the opacity transition.
        requestAnimationFrame(function () {
            lightbox.classList.add('is-visible');
        });
        document.body.style.overflow = 'hidden';

        if (inlineVideo && !isNaN(inlineVideo.currentTime)) {
            const resume = function () {
                bigVideo.currentTime = inlineVideo.currentTime;
                bigVideo.removeEventListener('loadedmetadata', resume);
            };
            if (bigVideo.readyState >= 1) resume();
            else bigVideo.addEventListener('loadedmetadata', resume);
        }

        const playing = bigVideo.play();
        if (playing && playing.catch) playing.catch(function () { /* autoplay blocked */ });

        closeBtn.focus();
    }

    function closeLightbox() {
        lightbox.classList.remove('is-visible');
        bigVideo.pause();
        document.body.style.overflow = '';
        setTimeout(function () { lightbox.classList.remove('active'); }, 250);
        if (lastTrigger) lastTrigger.focus();
    }

    triggers.forEach(function (trigger) {
        trigger.addEventListener('click', function () { openLightbox(trigger); });

        trigger.addEventListener('keydown', function (event) {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                openLightbox(trigger);
            }
        });
    });

    closeBtn.addEventListener('click', closeLightbox);

    // Clicking the scrim outside the card also closes it.
    lightbox.addEventListener('click', function (event) {
        if (event.target === lightbox) closeLightbox();
    });

    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && lightbox.classList.contains('active')) {
            closeLightbox();
        }
    });
});

/* Hero message carousel - the headline/sub-line pairs in #initial-section.
   It advances itself every 5s, but the slides live in a scroll-snap track
   rather than being cross-faded, so a reader who wants to go back through the
   messages can swipe, drag or use the dots. Auto-advance stands down while
   they do, and picks up again from wherever they left off. */
document.addEventListener('DOMContentLoaded', function () {
    const track = document.getElementById('heroRotator');
    const dotsWrap = document.getElementById('heroDots');
    if (!track) return;

    const slides = Array.from(track.querySelectorAll('.hero-slide'));
    if (slides.length < 2) return;

    const HOLD_MS = 5000;
    // How long auto-advance waits after the reader stops interacting
    const RESUME_MS = 8000;
    let timer = null;
    let resumeTimer = null;

    const currentIndex = () => Math.round(track.scrollLeft / track.clientWidth);

    const goTo = (index) => {
        track.scrollTo({ left: index * track.clientWidth, behavior: 'smooth' });
    };

    // Dots double as the manual control and as the position indicator
    const dots = slides.map((slide, index) => {
        if (!dotsWrap) return null;
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'hero-dot' + (index === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', `Show message ${index + 1} of ${slides.length}`);
        dot.addEventListener('click', () => {
            goTo(index);
            hold();
        });
        dotsWrap.appendChild(dot);
        return dot;
    });

    const syncDots = () => {
        const index = currentIndex();
        slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
        dots.forEach((dot, i) => dot && dot.classList.toggle('is-active', i === index));
    };

    const start = () => {
        clearInterval(timer);
        timer = setInterval(() => goTo((currentIndex() + 1) % slides.length), HOLD_MS);
    };

    const stop = () => {
        clearInterval(timer);
        timer = null;
    };

    // Stand down while the reader is driving, then resume after a pause
    const hold = () => {
        stop();
        clearTimeout(resumeTimer);
        resumeTimer = setTimeout(() => {
            resumeTimer = null;
            start();
        }, RESUME_MS);
    };

    // Hover and focus only pause; they must not cut a hold short
    const resume = () => {
        if (!resumeTimer) start();
    };

    let scrollSettle;
    track.addEventListener('scroll', () => {
        clearTimeout(scrollSettle);
        scrollSettle = setTimeout(syncDots, 100);
    }, { passive: true });

    track.addEventListener('pointerdown', hold);
    track.addEventListener('touchstart', hold, { passive: true });
    track.addEventListener('wheel', hold, { passive: true });
    track.addEventListener('mouseenter', stop);
    track.addEventListener('mouseleave', resume);
    track.addEventListener('focusin', stop);
    track.addEventListener('focusout', resume);

    track.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight') {
            event.preventDefault();
            goTo(Math.min(currentIndex() + 1, slides.length - 1));
            hold();
        } else if (event.key === 'ArrowLeft') {
            event.preventDefault();
            goTo(Math.max(currentIndex() - 1, 0));
            hold();
        }
    });

    // A resize changes the slide width the scroll offset is measured against
    let resizeTimer;
    window.addEventListener('resize', () => {
        const index = currentIndex();
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => goTo(index), 150);
    });

    // Don't burn cycles (or skip messages) while the tab is in the background
    document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
            stop();
        } else {
            resume();
        }
    });

    syncDots();
    start();
});
